import { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { setCookie } from "../../helpers/cookies";

const LoginAsUser = () => {
    const navigate = useNavigate()
    
    useEffect(() => {
        // localStorage.removeItem("coach_token")
        // localStorage.removeItem("user")
        localStorage.removeItem("selectedStudent")
        
        // Read token from cookies
        const token = Cookies.get("token")
        const user = Cookies.get("user")
    
        // If token exists, store it in localStorage
        if (token && user) {
            localStorage.setItem("coach_token", token)
            localStorage.setItem("coach_user", user)
            setCookie("coach_token", token, 1);

            console.log("Token set in localStorage:", token)
            return navigate("/profile")
        } else {
            return navigate("/profile")
        }
    }, []);

    return (
        <div>LoginAsUser</div>
    )
}

export default LoginAsUser